/**
 * Тексты доски. Утверждены владельцем: EOL_MVP_TASK.md § 7 (колонки, вехи,
 * ошибки доски, тексты фронта доски, слова из макета) и блоки «Тексты»
 * промтов S2, S2.1 и S2.2.
 */
export const TX = {
    // Шапка (знак и подписи иконок — из макета; «Закрыть», «Профиль» — подписи UI-кита)
    brand: "atom eol",
    profile: "Профиль",
    close: "Закрыть",
    search: "Поиск по VIN",
    /** Подсказка поиска журнала на телефоне (S18.1): поле 120 px. */
    searchVinShort: "VIN",
    addCar: "+ Машина",
    journal: "Журнал",
    board: "Доска",

    // Колонка
    ours: "наш этап",
    showMore: "Показать ещё",
    empty: "Пусто",
    waitsEngineer: "ждёт инженера",

    // Карточка
    take: "Взять в работу",
    takeAlert: "Беру",
    alertBy: (name: string) => `Алерт у ${name}`,
    resolveAlert: "Закрыть алерт",
    releaseAlert: "Я мухожук",
    doorsShort: "Двери",
    edit: "Изменить",
    openDiscussion: "Открыть обсуждение",
    copyVin: "Скопировать VIN",
    moreActions: "Ещё действия",

    // Панель машины
    inWorkBy: (name: string) => `В работе у ${name}`,
    onStage: (time: string) => `на этапе ${time}`,
    release: "Отказаться",
    alert: "Алерт",
    notDone: "не выполнено",
    history: "История",
    move: "Перенести",
    deleteCar: "Удалить машину",
    deleteCarConfirm: (vin: string) =>
        `Удалить машину ${vin}? Действие не отменить, история останется в журнале`,
    delete: "Удалить",

    // «Уехала» и возврат (S17.2, утверждены 01.11.2026)
    ship: "Уехала",
    shipConfirm: "Бро, точно отгружаем?",
    shipYes: "Отгружаем",
    unship: "Вернуть на доску",
    unshipConfirm: "Бро, возвращаем на доску?",
    unshipYes: "Возвращаем",

    // Закрытие этапа, доработка, алерт
    closeStage: (stage: string) => `Закрыть этап «${stage}»`,
    /** Статус вехи в панели и журнале. */
    done: "Готово",
    /** «Готово» в окне закрытия этапа (S2.1). */
    clean: "Чисто",
    withIssue: "С замечанием",
    /** Третий вариант у вехи (S6): веха не отправляется и остаётся как есть. */
    skip: "Пропустить",
    /** Перенос назад на этап с уже стоящей вехой (S6). */
    backToClosed: (stage: string) => `Этап «${stage}» уже закрыт. Вернуть машину на него?`,
    returnBack: "Вернуть",
    remark: "Замечание",
    enterAllClean: "Enter — всё «Чисто»",
    cancel: "Отмена",
    toRework: "На доработку",
    reworkWhat: "Что нужно доработать",
    alertWhat: "Что случилось",
    raiseAlert: "Поднять алерт",

    // Добавление машины и цвета
    newCar: "Новая машина",
    vin: "VIN",
    color: "Цвет",
    add: "Добавить",
    addColor: "Добавить цвет",
    colorName: "Название цвета",
    picture: "Картинка",
    /** Подсказка и ошибка поля VIN (S6): хранятся только 4 последних знака. */
    vinHint: "4 последних знака или VIN целиком",
    vinInvalid: "Неверный VIN: 4 последних знака или 17 символов, латиница и цифры, без I, O и Q",

    // Ошибки доски (дублируют бэкенд для проверок до отправки)
    remarkRequired: "Опишите замечание",
    colorRequired: "Выберите цвет",
    alertRequired: "Опишите причину алерта",

    // Журнал и история
    today: "Сегодня",
    yesterday: "вчера",
    todayLower: "сегодня",
    created: (stage: string) => `Добавлена на «${stage}»`,
    moved: (from: string, to: string) => `Перенесена «${from}» → «${to}»`,
    taken: "Взята в работу",
    alertRaised: "Поднят алерт",
    alertTaken: "Алерт взят",
    alertReleased: "Отказался от алерта",
    milestoneDone: (m: string) => `${m} — готово`,
    milestoneIssue: (m: string) => `${m} — с замечанием`,
    remarkChanged: (m: string) => `${m} — замечание изменено`,
    wasBecame: (was: string, became: string) => `было: «${was}» → стало: «${became}»`,
    released: "Снята с работы",
    milestoneCleared: (m: string) => `${m} — сброшена`,
    alertResolved: "Алерт закрыт",
    vinChanged: "VIN изменён",
    colorChanged: "Цвет изменён",
    noteChanged: "Что нужно доработать — изменено",
    deleted: "Удалена",
    shipped: "Уехала",
    unshipped: "Вернулась на доску",

    // «Стенды» и журнал «Все / Мои» (S18, утверждены 02.11.2026)
    atEnroll: "В ремзоне",
    atStands: "На стендах",
    toStands: "Уехала на стенды",
    backToEnroll: "Вернулась в ремзону",
    journalAll: "Все",
    journalMine: "Мои",
    clearMilestone: "Сбросить",

    // Время
    min: "мин",
    hour: "ч",
    /** Рабочие часы в Стате (S17.2): «9 ч 40 м». */
    minShort: "м",

    // Время последнего сообщения (S6): минуты и часы — «мин»/«ч» с числом; дни — без числа у единицы
    justNow: "только что",
    dayAgo: "день назад",
    ago: "назад",
    daysForms: ["день", "дня", "дней"],

    // Дата добавления на карточке (S4.3): «12 сен». Свой список: Intl даёт «сент.»
    monthsShort: ["янв", "фев", "мар", "апр", "май", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"],
} as const;
